import { RouteRecordRaw } from 'vue-router'

const WorkflowList = () => import('./components/WorkflowList.vue')
const WorkflowEditor = () => import('./components/WorkflowEditor.vue')

export const fsmRoutes: RouteRecordRaw[] = [
  {
    path: '/fsm',
    name: 'FsmWorkflows',
    component: WorkflowList,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/fsm/create',
    name: 'CreateWorkflow',
    component: WorkflowEditor,
    props: { mode: 'create' },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/fsm/:id/edit',
    name: 'EditWorkflow',
    component: WorkflowEditor,
    props: (route) => ({
      mode: 'edit',
      workflowId: Number(route.params.id),
    }),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/fsm/:id/view',
    name: 'ViewWorkflow',
    component: WorkflowEditor,
    props: (route) => ({
      mode: 'view',
      workflowId: Number(route.params.id),
    }),
    meta: {
      requiresAuth: true,
    },
  },
]
